import { usePathname } from 'next/navigation'

import {
  sideBarKeys,
  useSideBarData,
} from '@/pages/tad.ai/_layout/SideBar/data'

export function useInWhichPage() {
  const href = useSideBarData()
  const pathname = usePathname()
  const hrefMap = new Map(href.map((item) => [item.key, item.href]))

  const createHref = hrefMap.get(sideBarKeys.create)
  const inCreatePage = createHref ? pathname.includes(createHref) : false
  const libraryHref = hrefMap.get(sideBarKeys.library)
  const inLibraryPage = libraryHref ? pathname.includes(libraryHref) : false
  const homeHref = hrefMap.get(sideBarKeys.home)
  const inHomePage = homeHref ? pathname.includes(homeHref) : false
  const inDetailPage = /\/l\/.+$/.test(pathname)
  const inHomepageDetail = /\/homepage\/detail/.test(pathname)
  const aiCoverHref = hrefMap.get(sideBarKeys.aiCover)
  const inAiCoverPage = aiCoverHref ? pathname.includes(aiCoverHref) : false
  const aiRapHref = hrefMap.get(sideBarKeys.aiRap)
  const inAiRapPage = aiRapHref ? pathname.includes(aiRapHref) : false
  const ttsHref = hrefMap.get(sideBarKeys.tts)
  const inTtsPage = ttsHref ? pathname.includes(ttsHref) : false
  const shouldShowMusicTagLabel =
    inLibraryPage || inCreatePage || inAiRapPage || inAiCoverPage || inTtsPage

  const isIndexPage = pathname === '/'

  return {
    inCreatePage,
    inLibraryPage,
    inHomePage,
    inDetailPage,
    inHomepageDetail,
    inAiCoverPage,
    inAiRapPage,
    inTtsPage,
    shouldShowMusicTagLabel,
    isIndexPage,
  }
}
